module.exports = __webpack_public_path__ + "static/undraw_inbox_cleanup_w2ur-e5dd8608ba42c9522ca122daf5134430.svg";